import { axiosInstance } from "./apiConfig"

export const apiStoreSetup = async (id, language = 'en') => {
    try {
        const dateNow = new Date(Date.now());
        const date = `${dateNow.getFullYear()}-${dateNow.getMonth() + 1}-${dateNow.getDate()}`;
        const response = await axiosInstance.get(`/thirdparty/resdiary/store/${id}/setup?date=${date}&language=${language}`);
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}


// WEBPACK FOOTER //
// ./src/api/storeSetup.js